export default __webpack_public_path__ + "static/media/dashboard.fa9730aa.svg";